import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, tap, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class HttpinterceptorsInterceptor implements HttpInterceptor {

  constructor(private toastr: ToastrService, private router: Router) {}
  
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //const jwt = this.authService.getToken()
    return next.handle(request.clone({ setHeaders: { authorization: `Bearer`}} )).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse && event.status == 401) {
            this.throwError('Unauthorized access!');     
            return this.router.navigateByUrl("/login");       
          }
          return event;
        },
        error: (error) => {
          if(error.status === 401) {
            this.throwError('Unauthorized access!');    
            return this.router.navigateByUrl("/login");
          }
          else if (error.status === 400){            
            return this.throwError(error.error);  
          }
          else if (error.status === 500){
            return this.throwError(`Internal Server error`);  
          }
          else if(error.status === 404) {
            return this.throwError('Page Not Found!');
          }else if(error.status === 0){
            return this.throwError('Unable to connect to server');
          }
        }
      }));
  }

  throwError(message: string){
    this.toastr.error(message);
    console.log(message);    
  }
}
